import styled from 'styled-components'
import { NavigationBoldDownIcon } from 'components/Common/Icons'

const Wrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 100%;
  padding: 0;
  margin: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
  outline: none;

  svg {
    transform: ${props => (props.opened ? 'rotate(180deg)' : 'rotate(0deg)')};
  }

  :read-only,
  [readonly] {
    color: var(--color-sw-60);
  }

  :disabled,
  [disabled] {
    color: var(--color-sw-20);
  }
`

const Arrow = props => {
  const {
    toggleOpened,
    opened,
    disabled,
    readOnly,
    'data-testid': testId,
  } = props

  const handleClick = () => {
    if (!disabled && !readOnly && toggleOpened) {
      toggleOpened()
    }
  }

  return (
    <Wrapper
      onMouseDown={handleClick}
      opened={opened}
      type='button'
      tabIndex={-1}
      disabled={disabled}
      readOnly={readOnly}
      data-testid={testId}
    >
      <NavigationBoldDownIcon />
    </Wrapper>
  )
}

export default Arrow
